/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_Skill_CountInputs */

const en_tables_custom_pages_skill_count = /** @type {(inputs: Tables_Custom_Pages_Skill_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Skill Count`)
};

const de_tables_custom_pages_skill_count = /** @type {(inputs: Tables_Custom_Pages_Skill_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Skills`)
};

/**
* | output |
* | --- |
* | "Pages Skill Count" |
*
* @param {Tables_Custom_Pages_Skill_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_skill_count = /** @type {((inputs?: Tables_Custom_Pages_Skill_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_Skill_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_skill_count(inputs)
	return de_tables_custom_pages_skill_count(inputs)
});